/**
 * 銷貨單 React Query keys（hooks／invalidate 共用）。
 */
export function salesOrderListQueryKey(listQuery) {
  return ['erp', 'salesOrder', 'list', listQuery];
}

export function salesOrderListQueryKeyPrefix() {
  return ['erp', 'salesOrder', 'list'];
}

export function salesOrderDetailQueryKey(id) {
  return ['erp', 'salesOrder', 'detail', id];
}

export function salesOrderInventoryCandidatesQueryKey(id) {
  return ['erp', 'salesOrder', 'inventoryCandidates', id];
}

export function salesOrderSnCandidatesQueryKey(id) {
  return ['erp', 'salesOrder', 'snCandidates', id];
}
